import plugin_vue3_A0OWXRrUgq from "/opt/atlassian/pipelines/agent/build/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/opt/atlassian/pipelines/agent/build/.nuxt/components.plugin.mjs";
import vueuse_head_plugin_D7WGfuP1A0 from "/opt/atlassian/pipelines/agent/build/node_modules/nuxt/dist/head/runtime/lib/vueuse-head.plugin.mjs";
import router_Pg0DINazwm from "/opt/atlassian/pipelines/agent/build/node_modules/nuxt/dist/pages/runtime/plugins/router.mjs";
import prefetch_client_3cwHvxIDEX from "/opt/atlassian/pipelines/agent/build/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.mjs";
import cio_eKVGKC8WZ0 from "/opt/atlassian/pipelines/agent/build/plugins/cio.ts";
import firebase_client_nS52P0yitD from "/opt/atlassian/pipelines/agent/build/plugins/firebase.client.js";
import gallabox_MMYOCpP1ao from "/opt/atlassian/pipelines/agent/build/plugins/gallabox.ts";
import gtag_RbOvmu12fv from "/opt/atlassian/pipelines/agent/build/plugins/gtag.ts";
import header_B0qGH2L5CK from "/opt/atlassian/pipelines/agent/build/plugins/header.ts";
import hotjar_pBWYs5JQbk from "/opt/atlassian/pipelines/agent/build/plugins/hotjar.ts";
import jivochat_GvRD561Tn3 from "/opt/atlassian/pipelines/agent/build/plugins/jivochat.ts";
import optinmonster_EIhVqgesLl from "/opt/atlassian/pipelines/agent/build/plugins/optinmonster.ts";
import persist_storage_lW7kQE6rVg from "/opt/atlassian/pipelines/agent/build/plugins/persist-storage.ts";
import posthog_client_o9IEgU9LwG from "/opt/atlassian/pipelines/agent/build/plugins/posthog.client.js";
import sentry_client_shVUlIjFLk from "/opt/atlassian/pipelines/agent/build/plugins/sentry.client.ts";
import smartlook_6PeLsZF96W from "/opt/atlassian/pipelines/agent/build/plugins/smartlook.ts";
import tagmanager_CTMC49pKXm from "/opt/atlassian/pipelines/agent/build/plugins/tagmanager.ts";
import utm_manager_5fiIzQc6Of from "/opt/atlassian/pipelines/agent/build/plugins/utm-manager.ts";
export default [
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  vueuse_head_plugin_D7WGfuP1A0,
  router_Pg0DINazwm,
  prefetch_client_3cwHvxIDEX,
  cio_eKVGKC8WZ0,
  firebase_client_nS52P0yitD,
  gallabox_MMYOCpP1ao,
  gtag_RbOvmu12fv,
  header_B0qGH2L5CK,
  hotjar_pBWYs5JQbk,
  jivochat_GvRD561Tn3,
  optinmonster_EIhVqgesLl,
  persist_storage_lW7kQE6rVg,
  posthog_client_o9IEgU9LwG,
  sentry_client_shVUlIjFLk,
  smartlook_6PeLsZF96W,
  tagmanager_CTMC49pKXm,
  utm_manager_5fiIzQc6Of
]